import '../App.css';
import '../assets/styles/scout.css'
import sliderStyles from '../assets/styles/settings.module.css'
import homeStyles from '../assets/styles/home.module.css'
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDeviceInfo } from '../lib/mobile';
import { QRCodeSVG } from "qrcode.react";
import Backarrow from '../components/Backarrow';
import {useAuth} from "../lib/firebase";
import Toast from '../lib/toast';
import Wifi from '../components/Wifi';
import OctopusStatus from '../components/OctopusStatus';
import { getRobotFromMatch, getRobotFromElimsMatch, bBotLabel } from '../lib/tba';
import Timekeeper from './TImekeeper';
import { advanceRotation, loadRotation, saveRotation, ROBOTS_PER_MATCH } from '../lib/timekeepRotation';
import { playClickSound,playErrorSound,playStartSound, playUploadSound } from '../lib/audio';
import { getCurrentData, getCompressedQRData, canGenerateQRCodePayload, saveDataMap, uploadBlocker, copyString,formatData,isValidData } from '../lib/data';
import PickingSection from '../components/PickingSection';
import { masterConfig, gamemodes, elimsPositions, fillMissingFields } from '../configs/generalConfig';
import MoreStartOptions from '../components/MoreStartOptions';
import { submitMatch, showSubmitResult } from '../lib/submit';
import { primeUsbPermission, chooseUsbFolder, usbSupported } from '../lib/usb';
import { newSubmissionId, withSubmissionId } from '../lib/submissionId';
import { formSettingsFor } from '../lib/form';
import Field from '../components/Field';
import FieldPng from '@manta-scouting/shared-assets/rebuilt-field.png';
import confetti from "canvas-confetti";
import { motion } from "framer-motion";
import PopValue from '../components/PopValue';
import { useAnimation, useEnterAnimation } from '../lib/AnimationContext';


function Scout({currentTab, setCurrentTab,dataMap, setDataMap, setInitialDataMap, initialDataMap,eventPath,teamList,tbaOnline,tbaStatus,funnySounds,sfxEnabled,eventList,onlineStatus, settingsYear, setGameMode, gamemode, rebuiltMissType, setRebuiltMissType, refresh, scoutDataMap, setScoutDataMap,specialUpload, onPageChange}) {
    //inside this page make more separate pages for auto, tele, post match
    const { user, authentication, setAuthentication } = useAuth();
    const { device } = useDeviceInfo();
    const [currentPage, setCurrentPage] = useState("start");
    useEffect(() => {
        onPageChange?.(currentPage);
    }, [currentPage, onPageChange]);
    const [selectedDatapoint, setSelectedDatapoint] = useState("");
    const [matchGoing, setMatchGoing] = useState(0);
    const [pickingVisible, setPickingVisible] = useState(false);
    /**
     * Which QATA box the PickingSection popup is editing: "normal" (auto_qata/qata for the current
     * page, opened with Left Alt or by tapping the team label) or "defense" (defense_qata, opened with
     * Right Alt / AltGr / a tap of Right Shift, or by tapping the timer)
     */
    const [qataMode, setQataMode] = useState("normal");
    const rightShiftTapped = useRef(false);
    const [shouldAutoImportPicking, setShouldAutoImportPicking] = useState(false);
    const [gameSessionId, setGameSessionId] = useState(Date.now()); // Track game sessions
    // One id per match (lib/submissionId.js), new whenever the game session is: the QR,
    // the saved copy and the queued record all carry the same one, so the Pi stores
    // this match once however many ways it arrives. gameSessionId is unused inside on
    // purpose: it is listed so a new session mints a new id.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const submissionId = useMemo(() => newSubmissionId(), [gameSessionId]);
    const [milliseconds , setMilliseconds ] = useState(0);
    const [timerRunning, setTimerRunning] = useState(false);
    const [showElimsPosModal, setShowElimsPosModal] = useState(false);
    const [showQualsPosModal, setShowQualsPosModal] = useState(false);
    const [pendingGameMode, setPendingGameMode] = useState(null);
    const [displayMap, setDisplayMap] = useState(false);
    const [useCompressedUploadPayload, setUseCompressedUploadPayload] = useState(false);
    const { preset: animPreset } = useAnimation();
    const subpageRef = useRef(null);
    // Light entrance on each start/Auto/Tele/Post/Upload switch (never a stagger here - buttons have to
    // be fully usable the instant the page appears)
    useEnterAnimation(subpageRef, currentPage);
    let fieldMapData;

    function detectFieldCrossings(points = [], crossingConfig = null) {
        if (!crossingConfig || !Array.isArray(crossingConfig.crossX) || !Array.isArray(crossingConfig.crossYMappings)) {
            return new Map();
        }

        const parsedPoints = points
            .map((point) => String(point).split(",").map(Number))
            .filter(([x, y]) => Number.isFinite(x) && Number.isFinite(y));

        const crossX = crossingConfig.crossX;
        const xTolerance = Number(crossingConfig.xTolerance) || 0;
        const mappings = crossingConfig.crossYMappings;
        const hitStates = mappings.map(() => false);

        const isInAnyRange = (value, ranges = []) => ranges.some(([min, max]) => value >= min && value <= max);

        const inspectPoint = (x, y) => {
            const nearCrossLine = crossX.some((lineX) => Math.abs(x - lineX) <= xTolerance);
            if (!nearCrossLine) return;

            for (let i = 0; i < mappings.length; i++) {
                if (isInAnyRange(y, mappings[i].yRanges)) {
                    hitStates[i] = true;
                }
            }
        };

        for (let i = 0; i < parsedPoints.length; i++) {
            inspectPoint(parsedPoints[i][0], parsedPoints[i][1]);
        }

        for (let i = 0; i < parsedPoints.length - 1; i++) {
            const [x1, y1] = parsedPoints[i];
            const [x2, y2] = parsedPoints[i + 1];
            const steps = Math.max(Math.abs(x2 - x1), Math.abs(y2 - y1), 1) * 2;

            for (let step = 0; step <= steps; step++) {
                const t = step / steps;
                inspectPoint(x1 + (x2 - x1) * t, y1 + (y2 - y1) * t);
            }
        }

        const output = new Map();
        mappings.forEach((mapping, index) => {
            output.set(mapping.targetKey, hitStates[index] ? mapping.crossedValue : mapping.defaultValue);
        });

        return output;
    }

    //used in postmatch editing screen for toggle array value type items
    const [draftValue, setDraftValue] = useState("");
    useEffect(() => {
        if (selectedDatapoint?.writeType === "tog") {
            setDraftValue(JSON.stringify(dataMap.get(selectedDatapoint.label) || []));
        }
    }, [selectedDatapoint]);
    

    /**
     * For 2026 Rebuilt season only
     * If 0 its intervals, if 1 its counting, if its 2 its circle
     */
    const [rebuiltScoutingMode, setRebuiltScoutingMode] = useState(0);
    
    /**
     * Options are "abort", "toPost", "loading", "checker", and "nothing"
     */
    const [showNotification, setShowNotification] = useState("nothing");
    // A second tap while one Submit is still sending would queue the match twice.
    const submitting = useRef(false);
    /**
     * checkerMessage
     */
    const [checkerMessage, setCheckerMessage] = useState("");
    const [alertList, setAlertList] = useState([])
    /*  
        bassically this block is integrated for some rebuilt stuff. 
        if its 2026 and you chose the count mode then it sets it to count. 
        if not 2026 then it just sets settings to the settingsyear
    */
    const isCountMode = parseInt(settingsYear) === 2026 && rebuiltScoutingMode === 1;
    const configYear = isCountMode ? 8888 : settingsYear;
    const fieldCrossingConfig = masterConfig[configYear]?.fieldCrossing;
    const [settings, setSettings] = useState(structuredClone(masterConfig[configYear].mainSettings));
    const [gridSettings, setGridSettings] = useState(structuredClone(masterConfig[configYear].gridSettings));

    /*
        The form in use, computed from the mode as it is in this render. `settings` below is
        the same form kept in state for drawing the buttons, but it is set in an effect and
        lags one render behind a mode switch - so anything deciding a record's fields uses
        this, never `settings`.
    */
    const activeForm = useMemo(
        () => formSettingsFor(configYear, settingsYear, rebuiltMissType),
        [configYear, settingsYear, rebuiltMissType]
    );

    /** Creates  the settings object for displaying buttons and stuff on the screen */
    useEffect(() => {
        setSettings(formSettingsFor(configYear, settingsYear, rebuiltMissType));
        setGridSettings(structuredClone(masterConfig[configYear].gridSettings)); // add this line
    }, [configYear, rebuiltMissType]);

    /*
        Every record carries every field of the form in use, every time. The starting
        record comes from the year's base form, but count mode adds auto_field - so a
        match with no path drawn used to leave it out, and Octopus filed that match in a
        different version table from one with a path. Fill anything missing with its
        empty value (auto_field: []); existing values are never touched.

        It fills from `activeForm`, not `settings`. Starting a count-mode match deletes the
        *_intervals fields and switches mode in one render; `settings` was still the
        interval form then, and filling from it put those fields back - on the first match
        after loading only, which split it into its own table on the Pi.
    */
    useEffect(() => {
        const filled = fillMissingFields(dataMap, activeForm);
        if (filled !== dataMap) setDataMap(filled);
    }, [dataMap, activeForm, setDataMap]);

    const startScoutPage = masterConfig[settingsYear].startScoutPage;
    const initialPage = masterConfig[settingsYear].initialPage;
    const qataQuestions = masterConfig[settingsYear].qataQuestions;

    /**
     * Runs the Timer
     */
    useEffect(() => {
        let interval = null;
        if (timerRunning) {
            interval = setInterval(() => {
                setMilliseconds(prev => {
                    if (prev <= 0) {         
                        setTimerRunning(false); 
                        return 0;            
                    }
                    return prev - 10;
                });
            }, 10); // de-increments the timerr every 10 milliseconds
        } else if (!timerRunning && interval) {
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [timerRunning]);

    /**
     * Stores values for which keys have been pressed speicifcally for making them light up visually
     */
    const [pressedKey, setPressedKey] = useState(new Set());

    /**
     * Does the same thing as pressedKey but is for "time" buttons that get toggled on and off
     */
    const [timerButtons, setTimerButtons] = useState(new Set());
    const timerButtonsRef = useRef(timerButtons);

    /**
     * Does the same thing as pressedKey but is for "toggled" buttons that get toggled on and off for array adding
     */
    const [activeToggledButtons, setActiveToggledButtons] = useState(new Set());
    const [allToggledButtons, setAllToggledButtons] = useState(new Map());
    const activeToggledButtonsRef = useRef(activeToggledButtons);
    useEffect(() => {
        setAllToggledButtons(new Map());
        setActiveToggledButtons(new Map())

        for (const data of [settings.auto, settings.tele]){
            for (let i = 0; i < data.length; i++) {
                const point = data[i];
                if(point.writeType == "tog" && !allToggledButtons.has(point.label)){
                    setAllToggledButtons(prev => new Map(prev).set(point.label, 0));
                }
            }
        }
    }, [])

    /**
     * Keeps the idk what this si for probably improtatn tho
     */
    useEffect(() => {
        timerButtonsRef.current = timerButtons;
    }, [timerButtons]);

    useEffect(() => {
        activeToggledButtonsRef.current = activeToggledButtons;
    }, [activeToggledButtons]);

    /**
     * Updates all of the timer buttons
     */
    useEffect(() => {
        if (!timerRunning) return;
        const interval = setInterval(() => {
            setDataMap(prevMap => {
                const newMap = new Map(prevMap);
                timerButtonsRef.current.forEach(key => {
                    newMap.set(key, (parseInt(newMap.get(key)) || 0) + 1);
                });
                return newMap;
            });
        }, 1000);
        const interval2 = setInterval(() => {
            setAllToggledButtons(prevMap => {
                const newMap = new Map(prevMap);
                activeToggledButtonsRef.current.forEach(key => {
                    newMap.set(key, (parseInt(newMap.get(key)) || 0) + 10);
                });
                return newMap;
            });
        }, 10);

        return () => {
            clearInterval(interval)
            clearInterval(interval2)
        };
    }, [timerRunning]);

    /**
     * Boolean for whether or not to increment or deincrement
     */
    const holdingShift = useRef(false);
    const touchStartX = useRef(0);
    const touchMoved = useRef(false);

    /**
     * Records finger position when button is first clicked
     * @param {*} e 
     */
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
        touchMoved.current = false;
    };

    /**
     * Detects whether touch actions are swipe or just tapping by measuring distance moved
     * @param {*} e 
     */
    const handleTouchMove = (e) => {
        const diff = e.touches[0].clientX - touchStartX.current;
        if (Math.abs(diff) > 10) touchMoved.current = true;
    };

    /**
     * When finger is lifted from screen compares start position to end position to determine the swipe direction
     * If swipe left then deincrement if right then increment
     */
    const handleTouchEnd = (key, writeType, cycData = [], multiplier = 1, ui_id = null) => (e) => {
        e.preventDefault();
        const touchEndX = e.changedTouches[0].clientX;
        const diff = touchEndX - touchStartX.current;
        const neededDifference = 20;
        if (touchMoved.current) {
            if (diff > neededDifference) {
                handleDataChange(key, writeType, "", cycData, false, multiplier, ui_id);
            } else if (diff < -neededDifference) {
                handleDataChange(key, writeType, "", cycData, true, multiplier, ui_id);
            }
        } else {
            handleDataChange(key, writeType, "", cycData, false, multiplier, ui_id);
        }
    };

    const holdRef = useRef(null); // track intervals for each key
    const baseInterval = 1000; // starting interval
    const acceleration = 0.45; // multiplier per tick

    function startHold(decreasing) {
        if (holdRef.current) return; // already holding

        let interval = baseInterval;

        const tick = () => {
            if (selectedDatapoint !== "") {
            handleDataChange(
                selectedDatapoint.label,
                selectedDatapoint.writeType,
                "",
                selectedDatapoint.writeType === "cycG" ? selectedDatapoint.cycGOptions : [],
                decreasing,
                selectedDatapoint.multiplier
            );
            }

            interval = Math.max(50, interval * acceleration);
            holdRef.current = setTimeout(tick, interval);
        };

        tick(); // first tick immediately
    }

    function stopHold() {
        if (holdRef.current) {
            clearTimeout(holdRef.current);
            holdRef.current = null;
        }
    }
    /**
     * Target options are "start", "Auto", "Tele", "Post", "Upload"
     * @param {string} target page to switch to
     */
    const switchPage = (target) => {
        setSelectedDatapoint("");
        setTimerButtons(new Set());
        setActiveToggledButtons(new Set());
        setPickingVisible(false);
        setDisplayMap(false);

        if(target == "timekeep"){
            for (const [key, info] of Object.entries(settings.start)) {
                if(!initialDataMap.has(info.label)) continue;
                let value;
                if(startScoutData.has(info.label)){
                    value = startScoutData.get(info.label)
                } else{
                    value = initialDataMap.get(info.label);
                }
                if (value === undefined || value === null || (String(value).trim() === "" && !(info.label === "team_position" && gamemode === 3))){
                    Toast.error("Missing Nessesary Inputs: " + info.display,funnySounds );
                    return;
                } 
            }

            const newGameData = new Map(initialDataMap);
            for (const [key, value] of startScoutData) {
                if (newGameData.has(key)) newGameData.set(key, value);
            }
            setDataMap(newGameData)
            setCurrentPage(target)
            return

        }
        
        // Clear picking section selections when switching between Auto/Tele
        // This ensures each page starts with a clean slate for new selections
        if ((currentPage === "Auto" && target === "Tele") || (currentPage === "Tele" && target === "Auto")) {
            sessionStorage.removeItem(`pickingData_${target}_selections`);
            sessionStorage.removeItem(`pickingData_${target}_mode`);
            sessionStorage.removeItem(`pickingData_${target}_hasImported`);
            sessionStorage.removeItem(`pickingData_${target}_importCount`);
            // Don't clear questionsText - we want to preserve imported questions
        }
        
        if((currentPage == "Tele" || currentPage == "Auto") && target == "Post"){

            // // Security check: if pieces were scored but accuracy is still "N/A", have it send a confirmation
            // if(parseInt(settingsYear) === 2026){
            //     if ((parseInt(dataMap.get("auto_scoring")) || 0) > 0 && dataMap.get("auto_accuracy") === "N/A") {
            //         const proceed = window.confirm("Your robot has Auto scoring, but you left accuracy blank. Proceed, or go back and fix?");
            //         if (!proceed) return;
            //     }
            //     if ((parseInt(dataMap.get("tele_scoring")) || 0) > 0 && dataMap.get("tele_accuracy") === "N/A") {
            //         const proceed = window.confirm("Your robot has Tele scoring, but you left accuracy blank. Proceed, or go back and fix?");
            //         if (!proceed) return;
            //     }
            // }

            // Auto-import current page picking data before moving to Post page
            autoImportCurrentPagePickingData(currentPage);
            
            // Also auto-import the other page if it hasn't been imported yet
            if(currentPage == "Tele") {
                autoImportCurrentPagePickingData("Auto");
            } else if(currentPage == "Auto") {
                autoImportCurrentPagePickingData("Tele");
            }
            
            // Trigger auto-import for picking section if moving to Post page
            setShouldAutoImportPicking(true);
            setTimeout(() => setShouldAutoImportPicking(false), 100);
            
            setAlertList([]);
            NAChecker([]);

            return;
        }
        else if(currentPage === "start" && target === "Auto" && matchGoing === 0){
            setMatchGoing(1);
            // setTimerRunning(true);
            setCurrentPage(target);
            return;
        }
        else if(currentPage === "Auto" && target === "Tele" && matchGoing === 1){
            // Auto-import Auto page picking data before moving to Tele
            autoImportCurrentPagePickingData("Auto");
            setMatchGoing(2);
            setMilliseconds(140 * 1000);
            setCurrentPage(target);
            setTimerRunning(true);
            return;
        }
        else if(currentPage === "Tele" && target === "Auto"){
            // Auto-import Tele page picking data before moving back to Auto
            autoImportCurrentPagePickingData("Tele");
            setCurrentPage(target);
            return;
        }
        else if (currentPage === "Post" && target === "Upload"){
            // Special Upload keeps every field; Neptune reads its untouched (default) values as N/A.
            const flagged = new Map(dataMap);
            flagged.set("special_upload", specialUpload);
            setDataMap(flagged);
            setCurrentPage(target);
            return;
        }
        else setCurrentPage(target);
    };
    
    const [startScoutData, setStartScoutData] = useState(new Map);
    useEffect(() => {
        if (startScoutData.get("match_number") !== "") {
            setScoutDataMap(startScoutData);
            // console.log(startScoutData);
        }
    }, [startScoutData]);

    // Timekeeper rotation (lib/timekeepRotation.js): robots of this match timed so far
    const [tkRotation, setTkRotation] = useState(() => loadRotation(eventPath, gamemode));
    useEffect(() => {
        setTkRotation(loadRotation(eventPath, gamemode));
    }, [eventPath, gamemode]);

    /** After a Timekeeper submit: the next robot of the same match, or the next match once all six are done. */
    function timekeepSubmitted() {
        // Elims positions are captain / picks, not 1-3 per alliance: no rotation there.
        if (gamemode === 3) return switchPage("start");
        const match = parseInt(dataMap.get("match_number"));
        const res = advanceRotation(tkRotation, {
            eventPath, gamemode, match,
            color: dataMap.get("alliance_color"),
            position: dataMap.get("team_position"),
        });
        saveRotation(res.rotation);
        setTkRotation(res.rotation);
        const nextMatch = res.nextMatch ? match + 1 : match;
        setInitialDataMap(prev => {
            const next = new Map(prev);
            next.set("alliance_color", res.spot.color);
            next.set("team_position", res.spot.position);
            return next;
        });
        setStartScoutData(prev => {
            const next = new Map(prev);
            next.set("match_number", nextMatch);
            // A different robot now: TBA's for quals, typed in otherwise
            next.set("team_number", tbaOnline && gamemode === 2
                ? (getRobotFromMatch(nextMatch, res.spot.position, res.spot.color, teamList) ?? "")
                : "");
            return next;
        });
        switchPage("start");
    }

    const startScoutDataRef = useRef(startScoutData);
    useEffect(() => {
        startScoutDataRef.current = startScoutData;
    }, [startScoutData]);
    useEffect(() => {
        if (!tbaOnline || gamemode !== 3) return;
        const match = startScoutData.get("match_number");
        const color = initialDataMap.get("alliance_color");
        const pos = initialDataMap.get("team_position");
        //console.log("initialDataMap autofill trigger:", { match, color, pos });
        if (match && color && pos) {
            const result = getRobotFromElimsMatch("match_" + match, pos, color, teamList);
            //console.log("autofill result:", result);
            setStartScoutData(prev => {
                const next = new Map(prev);
                next.set("team_number", result);
                return next;
            });
        }
    }, [initialDataMap, teamList, tbaOnline, gamemode, startScoutData.get("match_number")]);
    /**
     * Contains the intiital scouting information like match and team number
     */
    useEffect(() => {
        let luffy = new Map();
        for (const key in startScoutPage) luffy.set(key, "");
        setStartScoutData(luffy);
    }, [currentTab]);

    /**
     * Handles post match data changing
     * @param {*} key 
     * @param {*} value 
     * @param {*} max 
     * @param {*} writeType 
     * @returns 
     */
    const handleInitialChange = (key, value,max,writeType) => {
        let tempMap = new Map(dataMap);
        let sanji = new Map(initialDataMap);
        if(writeType === "int"){
            if(String(value).length > 0 && ( (!/^\d+$/.test(String(value))) || parseInt(value) > parseInt(max) || parseInt(value) <= 0)){
                return;
            }
            tempMap.set(key, (parseInt(value)));
            sanji.set(key, parseInt(value))
        }
        else{
            if(value.length > parseInt(max)) return;
            tempMap.set(key, value);
            sanji.set(key, value);
        }
        setDataMap(new Map(tempMap))
        setInitialDataMap(new Map(sanji));
    };

    /**
     * Updates the startScoutData map which holds the match number and team number of the current scouting page
     * @param {string} key the name of the datapoint
     * @param {string} value the new value of the datapoint
     * @param {int} max max length of the input
     */
    const handleChange = (key, value, max = 20) => {
        const parsed = parseInt(value);
        if (!isNaN(parsed) && parsed > parseInt(max)) return;
        let tempMap = new Map(startScoutData);
        tempMap.set(key, isNaN(parsed) ? value : parsed);

        if (tbaOnline && key === "match_number" && gamemode === 2) {
            if (value != "") {
                tempMap.set(
                    "team_number",
                    getRobotFromMatch(
                        value,
                        initialDataMap.get(initialPage.team_position.label),
                        initialDataMap.get(initialPage.alliance_color.label),
                        teamList
                    )
                );
            }
        } else if (tbaOnline && key === "match_number" && gamemode === 3) {
            const color = tempMap.get("alliance_color");
            const pos = tempMap.get("team_position");
            if (value != "" && color && pos) {
                tempMap.set(
                    "team_number",
                    getRobotFromElimsMatch(
                        value,
                        pos,
                        color,
                        teamList
                    )
                );
            }
        }

        if (tbaOnline && key === "team_position" && gamemode === 3) {
            const currentMatch = tempMap.get("match_number");
            const color = tempMap.get("alliance_color");
            const pos = tempMap.get("team_position");
            //console.log("elims autofill:", { key, value, currentMatch, color, pos, tbaOnline, gamemode, teamList });
            if (currentMatch && color && pos) {
                const result = getRobotFromElimsMatch("match_" + currentMatch, pos, color, teamList);
                //console.log("autofill result:", result);
                tempMap.set("team_number", result);
            }
        }

        setStartScoutData(tempMap);
    };

    /**
     * Used in post match page to select datapoints in the editor
     * @param {string} key 
     */
    function selectDatapoint(key){
        setSelectedDatapoint(key);
    }

    /**
     * Handles picking section data selection
     */
    function handlePickingData(data) {
        handleDataChange(getQataKey(qataMode), "str", data);
    }

    /**
     * The dataMap key a QATA box writes to
     * @param {"normal"|"defense"} mode
     */
    function getQataKey(mode) {
        if (mode === "defense") return "defense_qata";
        return currentPage === "Auto" ? "auto_qata" : "qata";
    }

    /**
     * Opens the requested QATA box, or closes the popup if that same box is already open.
     * Opening the other box while one is open switches straight to it.
     * @param {"normal"|"defense"} mode
     */
    function toggleQata(mode) {
        if (currentPage !== "Auto" && currentPage !== "Tele") return;
        if (pickingVisible && qataMode === mode) {
            setPickingVisible(false);
            return;
        }
        setDisplayMap(false);
        setQataMode(mode);
        setPickingVisible(true);
    }
    /**
     * Clears all picking section data for both Auto and Tele
     */
    function clearAllPickingData() {
        // Clear all sessionStorage entries for picking data
        ['Auto', 'Tele', 'Defense'].forEach(page => {
            sessionStorage.removeItem(`pickingData_${page}_selections`);
            sessionStorage.removeItem(`pickingData_${page}_mode`);
            sessionStorage.removeItem(`pickingData_${page}_hasImported`);
            sessionStorage.removeItem(`pickingData_${page}_importCount`);
            sessionStorage.removeItem(`pickingData_${page}_questionsText`);
        });
    }

    /**
     * Auto-imports picking data for current page only before clearing
     */
    function autoImportCurrentPagePickingData(page) {
        const savedSelections = sessionStorage.getItem(`pickingData_${page}_selections`);
        const hasImported = sessionStorage.getItem(`pickingData_${page}_hasImported`) === 'true';
        
        if (savedSelections && !hasImported) {
            try {
                const selections = JSON.parse(savedSelections);
                const hasSelections = Object.keys(selections).some(key => 
                    selections[key] !== undefined && selections[key] !== ''
                );
                
                if (hasSelections) {
                    // Get the appropriate questions for this page
                    const questions = page === "Auto" ? qataQuestions.auto : qataQuestions.tele;

                    // Format the selections into a readable string with commas at end
                    const formattedData = Object.entries(selections)
                        .filter(([_, value]) => value !== undefined && value !== '')
                        .map(([questionIndex, value]) => {
                            const question = questions[parseInt(questionIndex)];
                            if (!question) return '';
                            return `${question.question} ${value},`;
                        })
                        .filter(text => text !== '')
                        .join('\n');

                    if (formattedData) {
                        const qataKey = page === "Auto" ? "auto_qata" : "qata";
                        const currentText = dataMap.get(qataKey) || '';
                        
                        // Check if this data is already imported to prevent duplication
                        if (!currentText.includes(formattedData)) {
                            const separator = currentText ? '\n' : '';
                            const newText = currentText + separator + formattedData;
                            
                            // Update the dataMap directly
                            setDataMap(prev => {
                                const newMap = new Map(prev);
                                newMap.set(qataKey, newText);
                                return newMap;
                            });
                        }
                    }
                    // Mark as imported after auto-import
                    sessionStorage.setItem(`pickingData_${page}_hasImported`, 'true');
                }
            } catch (error) {
                console.error('Error parsing saved selections for auto-import:', error);
            }
        }
    }

    /**
     * Handles all keypresses
    */  
    useEffect(() => {
        if (currentTab != 'scout' || showNotification !== "nothing") return;
        const handleKeyDown = (e) => {
            // A Right Shift "tap" (pressed and released with no other key in between) opens defense QATA.
            // Holding Right Shift while pressing a scoring key still decrements, same as Left Shift.
            if (e.code === "ShiftRight") {
                if (!e.repeat) rightShiftTapped.current = Date.now();
            } else {
                rightShiftTapped.current = false;
            }

            if (e.key === "Tab") {
                if(currentPage == "Auto" || currentPage == "Tele"){
                    e.preventDefault(); // stops browser from moving focus between thjiings
                }
            }
            else if(e.key === "Alt" || e.key === "AltGraph"){
                e.preventDefault();
                if (e.repeat) return; // holding Alt shouldn't flicker the popup open/closed
                // Right Alt (Right Option on Mac, AltGr on international layouts) = defense QATA,
                // Left Alt = the normal auto/tele QATA
                const isRightAlt = e.code === "AltRight" || e.key === "AltGraph";
                toggleQata(isRightAlt ? "defense" : "normal");
                return;
            }
            if (pickingVisible) {
                return; // Let PickingSection handle its own ESC key
            }

            switch (e.key) {
                case "Enter":
                    // page forwards
                    if (currentPage === "Auto") switchPage("Tele");
                    else if (currentPage === "Tele") switchPage("Post");
                    break;
                case "ArrowRight":
                    // page forward
                    if (currentPage === "Auto") switchPage("Tele");
                    else if (currentPage === "Tele") switchPage("Post");
                    break;

                case "ArrowLeft":
                    // page backward
                    if (currentPage === "Upload") switchPage("Post");
                    else if (currentPage === "Tele") switchPage("Auto");
                    break;
                case "Shift":
                    e.preventDefault();
                    holdingShift.current = true;
                    break;
                default:
                    break;
            }
            switch (currentPage) {
                case("Auto"):
                    for(const datapoint of settings.auto){
                        if(e.key.toLowerCase() === String(datapoint.trigger)){
                            handleDataChange(datapoint.label, datapoint.writeType, "", datapoint.cycGOptions, false, datapoint.multiplier, datapoint.ui_id);
                        }
                    }
                    break
                case("Tele"):
                    for(const datapoint of settings.tele){
                        if(e.key.toLowerCase() === String(datapoint.trigger)){
                            handleDataChange(datapoint.label, datapoint.writeType, "", datapoint.cycGOptions, false, datapoint.multiplier, datapoint.ui_id);
                        }
                    }
                    break
                default:
                    break;
            }
        };
        const handleKeyUp = (e) => {
            if (e.key === "Shift") {
                e.preventDefault();
                holdingShift.current = false;
            }
            if (e.code === "ShiftRight") {
                const pressedAt = rightShiftTapped.current;
                rightShiftTapped.current = false;
                // Only a quick, lone tap counts: Shift+letter (typing a capital in the box) never
                // reaches here as a tap, since the letter's keydown clears rightShiftTapped.
                // Tap opens defense QATA, or closes it if it's already open. It deliberately does
                // nothing while the normal QATA box is open, so a stray tap mid-note can't switch boxes.
                if (pressedAt && Date.now() - pressedAt < 600 && !(pickingVisible && qataMode !== "defense")) {
                    toggleQata("defense");
                }
            }
        }
        // Clicking/tapping a button while holding Right Shift is a decrement, not a tap
        const cancelShiftTap = () => { rightShiftTapped.current = false; };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);
        window.addEventListener("pointerdown", cancelShiftTap);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
            window.removeEventListener("pointerdown", cancelShiftTap);
        }
    }, [currentPage, dataMap, showNotification, pickingVisible, qataMode, handleDataChange]);
    // Added pickingVisible to dependencies! yo dhruv this looks suspicously chatgpted idk
    // Vinh, or whoever did this, you are like..., you really forgot to add handleDataChange to the dependency array. That is kinda important for updating it.
    // If you say you forgot, Vinh, I will do things.
    
    /**
     * Resets deincrement status when leaving and returning to the page
     */
    useEffect(() => {
        const handleVisibility = () => {
            if (!document.hidden) holdingShift.current = false;
        };
        document.addEventListener("visibilitychange", handleVisibility);
        return () => document.removeEventListener("visibilitychange", handleVisibility);
    }, []);
    
    /**
     * Handles changing the data on the post match editor section for datapoints
     * @param {*} key 
     * @param {*} writeType 
     * @param {*} strData 
     */
    function handleEditorData(key, writeType, strData){
        const newGameData = new Map(dataMap);
        switch (writeType) {
            case ("str"):
                newGameData.set(key, strData);
                setDataMap(new Map(newGameData));
                break;
            default: //for ints
                newGameData.set(key, parseInt(strData));
                setDataMap(new Map(newGameData));
                
        }
    }

    let helper = new Map() //deletes the extra double calls for the Tog buttons
    
    /**
     * Handles When Buttons are pressed or QATA is typed
     * @param {string} key the label of the datapoint
     * @param {string} writeType the type (int, str, cycG, bool)
     * @param {string} strData the data if the type is a str
     * @param {array} cycData an array that holds point values for datapoint
     * @param {string} ui_id optional unique identifier for button visual state (separate from data label)
     */


    function handleDataChange(key, writeType, strData = "", cycData = [], decreasing = false, multiplier = 1, ui_id = null){
        if(!timerRunning && matchGoing > 0 && writeType !== 'str' && (currentPage == "Auto" || currentPage == 'Tele')){
            if(key != "auto_field"){
                    setTimerRunning(true);

            }
        }
        const pressedId = ui_id || key;
        setPressedKey(prev => new Set(prev).add(pressedId));
        if(multiplier == undefined) multiplier = 1;

        const newGameData = new Map(dataMap);
        if(holdingShift.current) decreasing = true;

        if (writeType == "inc" && (currentPage == "Auto" || currentPage == "Tele")) {
            setTimerButtons(prev => {
                const next = new Set(prev);
                if (next.has(key)) next.delete(key);
                else next.add(key);
                return next;
            });
            //console.log("Toggling " + key)
        }
        else { switch (writeType) {
            case ("tog"):
                if(currentPage == "Auto" || currentPage == "Tele"){
                    setActiveToggledButtons(prev => {
                        const next = new Set(prev);
                        if (next.has(key)) {
                            next.delete(key);
                            const dataTime = allToggledButtons.get(key);
                            // let tempArray = [...(newGameData.get(key) ?? [])];
                            let tempArray = [...newGameData.get(key) || []];
                            
                            const valueExists = Array.from(helper.values()).includes(dataTime);
                            //console.log("here!", helper)
                            
                            let doNothing = false;
                            if(valueExists){
                                let theVal = 0;
                                for (const [key, value] of helper.entries()) {
                                    if (value === dataTime) {
                                    theVal = key; // Return the key as soon as the value matches
                                    }
                                }
                                if(Math.abs(theVal - Date.now() < 250)){
                                    doNothing = true;
                                }
                            }
                            if (!doNothing) tempArray.push(dataTime);
                            helper.set(Date.now(), dataTime);
                            newGameData.set(key, tempArray);
                            setDataMap(new Map(newGameData));
                        }
                        else {
                            next.add(key);
                            setAllToggledButtons(prevMap => {
                                const newMap = new Map(prevMap);
                                newMap.set(key, 0);
                                // activeToggledButtonsRef.current.forEach(key => {
                                //     newMap.set(key, 0);
                                // });
                                return newMap;
                            });

                        }
                        return next;
                    });
                }
                break

            case ("str"):
                newGameData.set(key, strData);
                setDataMap(new Map(newGameData));
                if(currentPage == "Post"){
                    if(settings.start.includes(key)){
                        let zenitsu = new Map(initialDataMap);
                        zenitsu.set(key, strData);
                        setInitialDataMap(zenitsu);
                    }
                }
                //console.log("Changing " + key + " to: " + strData)
                break;
            case ("cycG"):
                let matched = false;
                for(let i = 0; i < cycData.length; i++){
                    if(String(cycData[i]) == String(dataMap.get(key))){
                        matched = true;
                        let value;
                        if(decreasing){
                            value = i == 0 ? cycData[cycData.length - 1] : cycData[i - 1];
                        } else {
                            value = i == cycData.length - 1 ? cycData[0] : cycData[i + 1];
                        }
                        newGameData.set(key, value);
                        setDataMap(new Map(newGameData));
                        break;
                    }
                }
                if (!matched) {
                    newGameData.set(key, cycData[0]);
                    setDataMap(new Map(newGameData));
                }
                break;
            case ("bool"):
                newGameData.set(key, !(dataMap.get(key)));
                setDataMap(new Map(newGameData));
                // console.log("Toggling " + key)
                break
            case ("popup"):
                if(parseInt(settingsYear) === 2026){
                    if(key == "auto_field"){ //hardcoded name for rebuilt map is here

                        setDisplayMap(prev => !prev)
                    }
                }
                break;
            default: //for ints
                let val = decreasing ? -1 : 1;
                val *= multiplier;
                setDataMap(prev => {
                    const newMap = new Map(prev);
                    let newNum = (parseInt(prev.get(key)) || 0) + val;
                    newNum = newNum <= 0 ? 0 : newNum;
                    newMap.set(key, newNum);
                    return newMap;
                });
                newGameData.set(key, (parseInt(dataMap.get(key)) + val));
                // console.log("Changing " + key + " to: " + (parseInt(dataMap.get(key)) + val))
                
        }}
        if(currentPage != "Post" && !pickingVisible){
            playClickSound(funnySounds,sfxEnabled);
        }
        setTimeout(() => {
            setPressedKey(prev => {
                const next = new Set(prev);
                next.delete(pressedId);
                return next;
            });
        }, 150);
    }

    /**
     * Starts scouting and moves to the Auto Page
     * @param {*} scoutMode changes the mode of scouting. 0 = default
     * @returns
     */
    function startScouting(scoutMode = 0) {
        // Clear picking data at the start of a new game
        clearAllPickingData();
        
        // Change game session ID to force PickingSection to reload
        setGameSessionId(Date.now());

        for (const [key, info] of Object.entries(settings.start)) {
            if(!initialDataMap.has(info.label)) continue;
            let value;
            if(startScoutData.has(info.label)){
                value = startScoutData.get(info.label)
            } else{
                value = initialDataMap.get(info.label);
            }
            if (value === undefined || value === null || (String(value).trim() === "" && !(info.label === "team_position" && gamemode === 3))){
                Toast.error("Missing Nessesary Inputs: " + info.display,funnySounds );
                return;
            } 
        }

        const newGameData = new Map(initialDataMap);
        for (const [key, value] of startScoutData) {
            if (newGameData.has(key)) newGameData.set(key, value);
        }
        

        if(parseInt(settingsYear) === 2026){
            if(rebuiltMissType){
                newGameData.delete("auto_accuracy")
                newGameData.delete("tele_accuracy")
                newGameData.set("auto_miss", 0);
                newGameData.set("tele_miss", 0);
            }
            if(scoutMode === 1){
                setRebuiltScoutingMode(1);
                newGameData.delete("auto_scoring_intervals")
                newGameData.delete("auto_feeding_intervals")
                newGameData.delete("tele_scoring_intervals")
                newGameData.delete("tele_feeding_intervals")
                newGameData.set("auto_scoring", 0);
                newGameData.set("auto_feeding", 0);
                newGameData.set("tele_feeding", 0);
                newGameData.set("tele_scoring", 0);
            }
            else{
                setRebuiltScoutingMode(0);
            }
        }
        
        setDataMap(new Map(newGameData));
        switchPage("Auto");
        playStartSound(funnySounds,sfxEnabled);
        setMatchGoing(1);
        setMilliseconds(170 * 1000);
    }

    function abortMatch(){
        setShowNotification("nothing")
        const newGameData = new Map(initialDataMap);
        setDataMap(new Map(newGameData));
        setTimerRunning(false);
        setMilliseconds(false);
        setMatchGoing(0);
        clearAllPickingData(); // Clear picking section data
        setGameSessionId(Date.now()); // Reset game session
        switchPage("start");
        setShowNotification("nothing")
    }

    /**
     * Submit: save locally, export to the Pi / USB when reachable, upload when online -
     * then one toast for the highest level reached (lib/submit.js). An invalid match is
     * the only thing that stays on this page: nothing is saved, queued or sent - just a
     * toast saying what's wrong - until it's fixed (user, Oct 2026).
     */
    async function handleSubmit(){
        if (submitting.current) return;
        submitting.current = true;
        try {
            await submitOnce();
        } finally {
            submitting.current = false;
        }
    }

    /**
     * Export: pick a folder (opens in the last one - the flash drive), save locally and write the
     * queue file there. No Pi, no upload; Submit does those. The folder becomes the Settings USB folder too.
     */
    async function handleExportToFolder(){
        if (submitting.current) return;
        submitting.current = true;
        try {
            await submitOnce({ usbOnly: true });
        } finally {
            submitting.current = false;
        }
    }

    async function submitOnce({ usbOnly = false } = {}){
        setShowNotification("nothing");
        // Asked first, while the tap still lets the browser show a permission prompt / folder picker.
        const usbReady = usbOnly ? chooseUsbFolder().then(Boolean, () => false) : primeUsbPermission();
        // Filled here too, in case Submit runs before the effect above has.
        const theData = withSubmissionId(
            fillMissingFields(dataMap, activeForm),
            submissionId);
        const num = theData.get("match_number");
        if (!num) {
            Toast.error("Not submitted - no match number", funnySounds, sfxEnabled);
            return;
        }
        const formatted = formatData(theData);
        // An invalid match goes nowhere - not saved on this device, not queued, not sent - just a
        // toast (user, Oct 2026); isValidData shows which field is wrong. The N/A rules (accuracy /
        // auto path / crossing left blank) are warnings only: the scout already saw them during the
        // match and chose to proceed, so they never stop a Submit.
        if (!formatted || !isValidData(formatted, settingsYear)) { // both toast what's wrong
            playErrorSound(funnySounds, sfxEnabled);
            return;
        }

        setShowNotification("loading");
        const result = await submitMatch({
            record: formatted,
            saveCopy: () => saveDataMap(num, theData, gamemode),
            gamemode,
            eventPath,
            uploadBlocked: uploadBlocker(user, authentication, theData, eventPath, eventList, onlineStatus, settingsYear),
            usbReady,
            usbOnly,
        });
        setShowNotification("nothing");
        if (usbOnly && !result.exportedTo.includes('USB') && result.level !== 'error') {
            // Folder cancelled or unwritable: the match is saved, stay here so they can try again.
            Toast.saved('Saved to local storage - not exported (no folder)');
            return;
        }
        showSubmitResult(result, funnySounds, sfxEnabled);
        if (result.level === 'error') {
            playErrorSound(funnySounds, sfxEnabled);
            return;
        }
        playUploadSound(funnySounds, sfxEnabled);
        // A normal match ends any Timekeeper rotation: back to plain +1 match numbers.
        if (tkRotation) {
            saveRotation(null);
            setTkRotation(null);
        }
        handleChange("match_number", String(parseInt(dataMap.get("match_number")) + 1), startScoutPage.match_number.maxLength);
        clearAllPickingData();
        setGameSessionId(Date.now());
        confetti({ particleCount: 300, spread: 600, origin: { y: 0.6 } });
        switchPage("start");
    }

    function toggleUploadPayloadMode() {
        if (useCompressedUploadPayload) {
            setUseCompressedUploadPayload(false);
            return;
        }

        const compressedPayload = getCompressedQRData(withSubmissionId(dataMap, submissionId));
        if (!canGenerateQRCodePayload(compressedPayload)) {
            // eslint-disable-next-line no-restricted-globals
            alert("Unable to form a scannable compressed QR code. Staying on uncompressed mode.");
            setUseCompressedUploadPayload(false);
            return;
        }

        setUseCompressedUploadPayload(true);
    }

    

    const renderPage = (item) => {
        let plainQrPayload;
        let compressedQrPayload;
        // The QR carries the match's id, so a scanned copy is the same match to the Pi.
        const qrDataMap = withSubmissionId(dataMap, submissionId);
        plainQrPayload = getCurrentData(qrDataMap);
        compressedQrPayload = getCompressedQRData(qrDataMap);
        
        const qrPayload = useCompressedUploadPayload ? compressedQrPayload : plainQrPayload;
        const canShowQr = canGenerateQRCodePayload(qrPayload);
        const canShowCompressedQr = canGenerateQRCodePayload(compressedQrPayload);
        const qrUnavailableHint = useCompressedUploadPayload
            ? "Unable to form a scannable QR code. Use match data."
            : (canShowCompressedQr
                ? "Unable to form a scannable QR code. Use compressed."
                : "Unable to form a scannable QR code. Use match data.");
        switch (item) {
            case "Auto":
                return (
                    <>
                    <div className={`scoutingPageAuto${gridSettings.auto.rc}`}>
                        {Object.entries(settings.auto).map(([key, info]) => ( //makes the buttons
                            <div 
                                key={`${info.ui_id || key}Button`} 
                                className='btnContainer'
                                style={{gridColumnStart: info.columnStart, gridColumnEnd: info.columnEnd, gridRowStart: info.rowStart, gridRowEnd: info.rowEnd}}>
                                    <button
                                        className={`appearanceBtnElem 
                                                    ${info.label.toLowerCase().includes("time") 
                                                        && timerButtons.has(info.label) ? "activeBtn" : ""} 
                                                    ${pressedKey.has(info.ui_id || info.label) ? "activeBtn" : ""}
                                                    ${info.writeType.toLowerCase().includes("bool") 
                                                        && dataMap.get(info.label) ? "activeBtn" : ""} 
                                                    ${info.writeType.toLowerCase().includes("tog") 
                                                        && activeToggledButtons.has(info.label) ? "activeBtn" : ""} 
                                                        `}
                                        
                                            onTouchStart={ handleTouchStart}
                                            onTouchMove= {handleTouchMove}
                                            onTouchEnd={handleTouchEnd(info.label, info.writeType, info.cycGOptions, info.multiplier, info.ui_id)}
                                                        
                                            onClick={ () => {
                                                (handleDataChange(info.label, info.writeType, "", info.cycGOptions, false, info.multiplier, info.ui_id)) 
                                            }}
                                        >
                                        <span className='centerDisplay'>{info.display}</span>
                                        <span className={`triggerDisplay smallDisplay`}>{info.trigger}</span>
                                        <PopValue className='valueDisplay smallDisplay' noPop={info.writeType.toLowerCase().includes("tog")} value={
                                            info.writeType.toLowerCase().includes("tog") ?
                                                (activeToggledButtons.has(info.label) ? (allToggledButtons.get(info.label) / 1000).toFixed(1) + "s" : "0.0s")
                                                : (info.writeType.toLowerCase().includes("popup")) ?
                                                    "" :
                                                (() => {
                                                    const val = dataMap.get(info.label);
                                                    if (val === undefined || val === null) {
                                                        return info.cycGOptions && typeof info.cycGOptions[0] === "string" ? "N/A" : "0";
                                                    }
                                                    return String(val);
                                                })()
                                        } />
                                    </button>
                            </div>
                        ))}
                        <div className={`pageButton matchLabelAuto${gridSettings.auto.rc}`} onClick={() => toggleQata("normal")}>
                            <span style={{fontWeight:"bold"}}>Auto</span>
                            <span>Team: {dataMap.get("team_number")}</span>
                        </div>
                        <div className={`extraSectionAuto${gridSettings.auto.rc}`}>
                            <button
                                type="button"
                                className={matchGoing > 0 ? 'timer timerButton' : "invisible"}
                                title="Timer - tap for Defense QATA (Right Alt / Right Shift)"
                                onMouseDown={(e) => e.preventDefault()} // keep focus off it so Enter/Space keep paging instead of re-clicking
                                onClick={() => toggleQata("defense")}
                            ><span className="timerLabel">Timer: </span><span className="timerIcon" aria-hidden="true">⏱ </span>{(milliseconds / 1000).toFixed(2)}</button>
                            <button className='abortBtn' onClick={() => {setShowNotification("abort") }}>Abort</button>
                        </div>
                        <button className={`nextButtonAuto${gridSettings.auto.rc} pageButton`} onClick={() => switchPage('Tele')}>Next</button>
                    </div>
                    <Field
                        currentlyActive={displayMap}
                        onRequestClose={() => setDisplayMap(false)}
                        imageSrc={FieldPng}
                        initialData={dataMap.get("auto_field") || []}
                        onChange={(points) => {
                            setDataMap(prev => {
                                const newMap = new Map(prev);
                                newMap.set("auto_field", points);

                                const crossingUpdates = detectFieldCrossings(points, fieldCrossingConfig);
                                crossingUpdates.forEach((value, key) => {
                                    newMap.set(key, value);
                                });

                                return newMap;
                            });
                        }}
                        imageWid={600}
                        imageHght={315}
                        allianceColor={dataMap.get("alliance_color") || "n"}
                        gamemode={gamemode}
                    />   
                    </>
                );
            case "Tele":
                return (
                    <>
                    <div className='scoutingPage'>
                        {Object.entries(settings.tele).map(([key, info]) => ( //makes the buttons
                            <div 
                                key={`${info.ui_id || key}Button`} 
                                className='btnContainer'
                                style={{gridColumnStart: info.columnStart, gridColumnEnd: info.columnEnd, gridRowStart: info.rowStart, gridRowEnd: info.rowEnd, width: `calc((${info.columnEnd}-${info.columnStart})*23vw + (${info.columnEnd}-${info.columnStart}-1)*1.5vw)`, height: `calc((${info.rowEnd}-${info.rowStart})*19.5vh + (${info.rowEnd}-${info.rowStart}-1)*1.5vw)`}}>
                                    <button
                                        className={`appearanceBtnElem 
                                                    ${info.label.toLowerCase().includes("time") 
                                                        && timerButtons.has(info.label) ? "activeBtn" : ""} 
                                                    ${pressedKey.has(info.ui_id || info.label) ? "activeBtn" : ""}
                                                    ${info.writeType.toLowerCase().includes("bool") 
                                                        && dataMap.get(info.label) ? "activeBtn" : ""} 
                                                    ${info.writeType.toLowerCase().includes("tog") 
                                                        && activeToggledButtons.has(info.label) ? "activeBtn" : ""} 
                                                        `}
                                            onTouchStart= {handleTouchStart}
                                            onTouchMove= {handleTouchMove}
                                            onTouchEnd= {handleTouchEnd(info.label, info.writeType, info.cycGOptions, info.multiplier, info.ui_id)}
                                            onClick= {() => {
                                                (handleDataChange(info.label, info.writeType, "", info.cycGOptions, false, info.multiplier, info.ui_id))
                                            }}
                                        >
                                        <span className='centerDisplay'>{info.display}</span>
                                        <span className={`triggerDisplay smallDisplay`}>{info.trigger}</span>
                                        <PopValue className='valueDisplay smallDisplay' noPop={info.writeType.toLowerCase().includes("tog")} value={
                                                info.writeType.toLowerCase().includes("tog") ?
                                                    (activeToggledButtons.has(info.label) ? (allToggledButtons.get(info.label) / 1000).toFixed(1) + "s" : "0.0s")
                                                    : String(dataMap.get(info.label)
                                                    )
                                                } />
                                    </button>
                            </div>
                        ))}

                        <div className='pageButton matchLabel' onClick={() => toggleQata("normal")}>
                            <span style={{fontWeight:"bold"}}>Tele</span>
                            <span>Team: {dataMap.get("team_number")}</span>
                        </div>
                        <div className='extraSection'>
                            <button
                                type="button"
                                className='timer timerButton'
                                title="Timer - tap for Defense QATA (Right Alt / Right Shift)"
                                onMouseDown={(e) => e.preventDefault()} // keep focus off it so Enter/Space keep paging instead of re-clicking
                                onClick={() => toggleQata("defense")}
                            ><span className="timerLabel">Timer: </span><span className="timerIcon" aria-hidden="true">⏱ </span>{(milliseconds / 1000).toFixed(2)}</button>
                            <button className='abortBtn' onClick={() => {setShowNotification("abort") }}>Abort</button>
                        </div>
                        <button className='prevButton pageButton' onClick={() => switchPage('Auto')}>Prev</button>
                        <button className='nextButton pageButton' onClick={() => switchPage('Post')}>Next</button>
                    </div>  
                    </>
                );
            case "Post":
                return (
                    <>
                        <div className={device === "desktop" ? "scoutingPage" : "mobileScoutingPage"}>
                            <div className='postmatchQataSection'>
                                {Object.entries(settings.after).map(([key, info]) => (
                                    <>
                                        <span>{info.display}</span>
                                            <textarea 
                                                className="postQata appearanceForm"
                                                value={dataMap.get(info.label) || ""}
                                                onChange={e => handleDataChange(info.label, info.writeType, e.target.value)}
                                                placeholder={info.placeholder}
                                            />
                                    </>
                                ))}
                            </div>
                            <Field
                                currentlyActive={displayMap}
                                onRequestClose={() => setDisplayMap(false)}
                                imageSrc={FieldPng}
                                initialData={dataMap.get("auto_field") || []}
                                onChange={(points) => {
                                    setDataMap(prev => {
                                        const newMap = new Map(prev);
                                        newMap.set("auto_field", points);

                                        const crossingUpdates = detectFieldCrossings(points, fieldCrossingConfig);
                                        crossingUpdates.forEach((value, key) => {
                                            newMap.set(key, value);
                                        });

                                        return newMap;
                                    });
                                }}
                                imageWid={600}
                                imageHght={315}
                                allianceColor={dataMap.get("alliance_color") || "n"}
                                gamemode={gamemode}
                            />
                            <div className='postmatchInitalSection'>
                                {Object.entries(settings.start).map(([key, value]) => (
                                    <div key={key}>
                                        <p>{value.display}</p>
                                        <div>
                                            {value.label == "alliance_color" ? ( //HARD CODED
                                                <div>
                                                    <label>
                                                        <input
                                                        type="radio"
                                                        name="color"
                                                        value="r"
                                                        checked={dataMap.get(value.label) === "r"}
                                                        onChange={e => handleDataChange(value.label, value.writeType, e.target.value)}
                                                        />
                                                        Red
                                                    </label>
                                                    <label>
                                                        <input
                                                        type="radio"
                                                        name="color"
                                                        value="b"
                                                        checked={dataMap.get(value.label) === "b"}
                                                        onChange={e => handleDataChange(value.label, value.writeType, e.target.value)}
                                                        />
                                                        Blue
                                                    </label>
                                                </div>) : (
                                                <input 
                                                    maxLength={value.maxLength}
                                                    className="postQataMini"
                                                    key={`${key}_inputqatamini`}
                                                    type={value.label.includes("id") ? "text" : "number"}
                                                    inputMode={value.label.includes("id") ? "text" : "numeric"}
                                                    value={dataMap.get(value.label) || ""}
                                                    onChange={e => handleInitialChange(value.label, e.target.value,value.maxLength,value.writeType)}
                                                    placeholder={value.placeholder}
                                                    style={{
                                                        border: dataMap.get(value.label) === ""
                                                            ? "1.5px solid var(--errColor)"  
                                                            : ""
                                                        }}
                                                /> )
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className='postmatchDataSection'>
                                <div className='editorTitle'>
                                    <span className='editorTitle1'>Item</span>
                                    <span className='editorTitle2'>Value</span>
                                </div>
                                <p className='editorSubtitle'>Auto</p>
                                {(() => {
                                    const groupLabels = settings.imported?.groupSharedLabels;
                                    const seenLabels = new Set();
                                    return Object.entries(settings.auto).map(([key, info]) => {
                                        if (groupLabels && seenLabels.has(info.label)) return null;
                                        seenLabels.add(info.label);
                                        const displayName = groupLabels ? info.display.replace(/ x\d+$/, '') : info.display;
                                        const value = dataMap.get(info.label);
                                        const displayValue = Array.isArray(value) ? `[${value.join(', ')}]` : String(value);
                                        return (
                                            <div key={info.ui_id || key} className='editorSection' onClick={() => {info.label === "auto_field" ? setDisplayMap(true) : selectDatapoint(info)}}>
                                                <span>{displayName}</span>
                                                <span>{info.writeType==="popup" ? "AutoDrawing" : displayValue}</span>
                                            </div>
                                        );
                                    });
                                })()}
                                <span className='editorSubtitle'>Tele</span>
                                {(() => {
                                    const groupLabels = settings.imported?.groupSharedLabels;
                                    const seenLabels = new Set();
                                    return Object.entries(settings.tele).map(([key, info]) => {
                                        if (groupLabels && seenLabels.has(info.label)) return null;
                                        seenLabels.add(info.label);
                                        const displayName = groupLabels ? info.display.replace(/ x\d+$/, '') : info.display;
                                        const value = dataMap.get(info.label);
                                        const displayValue = Array.isArray(value) ? `[${value.join(', ')}]` : String(value);
                                        return (
                                            <div key={info.ui_id || key} className='editorSection' onClick={() => {selectDatapoint(info) }}>
                                                <span>{displayName}</span>
                                                <span>{displayValue}</span>
                                            </div>
                                        );
                                    });
                                })()}
                            </div>
                            <div className='editorBar'>
                                {selectedDatapoint.writeType === "tog" ? (
                                    <input
                                        type="text"
                                        value={draftValue}
                                        className='editorBarInput editorBarInputWide'
                                        disabled = {selectedDatapoint === "" || !selectedDatapoint}
                                        onChange={(e) => {
                                            setDraftValue(e.target.value);
                                        }}
                                        onBlur={() => {
                                            try {
                                                const parsed = JSON.parse(draftValue);
                                                if (Array.isArray(parsed)) {
                                                    const newMap = new Map(dataMap);
                                                    newMap.set(selectedDatapoint.label, parsed);
                                                    setDataMap(newMap);
                                                }
                                            } catch {
                                                setDraftValue(JSON.stringify(dataMap.get(selectedDatapoint.label) || []));
                                            }
                                        }}
                                    />
                                ) : (
                                    <>
                                        <button
                                            className="incrementerBtn"
                                            onMouseDown={() => startHold(true)}
                                            onMouseUp={() => stopHold()}
                                            onMouseLeave={() => stopHold()}
                                            onTouchStart={(e) => {
                                                e.preventDefault();
                                                startHold(true);
                                            }}
                                            onTouchEnd={(e) => {
                                                e.preventDefault();
                                                stopHold();
                                            }}
                                        >
                                            -
                                        </button>
                                        <input
                                            type="number"
                                            value={selectedDatapoint != "" ? dataMap.get(selectedDatapoint.label) ?? 0 : ""}
                                            className='editorBarInput'
                                            inputMode='numeric'
                                            disabled = {selectedDatapoint.writeType === "cycG" || selectedDatapoint.writeType === "bool" || selectedDatapoint === "" || !selectedDatapoint ? true : false}
                                            onChange={(e) => (handleEditorData(selectedDatapoint.label,selectedDatapoint.writeType,e.target.value))}
                                        />
                                        <button
                                            className="incrementerBtn"
                                            onMouseDown={() => startHold(false)}
                                            onMouseUp={() => stopHold()}
                                            onMouseLeave={() => stopHold()}
                                            onTouchStart={(e) => {
                                                e.preventDefault();
                                                startHold(false);
                                            }}
                                            onTouchEnd={(e) => {
                                                e.preventDefault();
                                                stopHold();
                                            }}
                                        >
                                            +
                                        </button>
                                    </>
                                )}
                            </div>
                            {device === "desktop" ? (
                                <>
                                    <button style={{ gridRow: "5/6", gridColumn:"4/5", alignSelf:"center",justifySelf:"right"}}  className='abortBtn' onClick={() => {setShowNotification("abort") }}>Abort</button>
                                    <button className='nextButton2 pageButton' onClick={() => switchPage('Upload')}>Next</button>
                                </>
                            ) : (
                                <>
                                <div className='extrasStuffs'>
                                    <button className='nextButton2 pageButton' onClick={() => switchPage('Upload')}>Next</button>
                                    <button className='abortBtn' onClick={() => {setShowNotification("abort") }}>Abort</button>
                                </div>
                                <div style={{visibility:"hidden"}}>I &lt;3 one piece</div>
                                </>
                            )}
                        </div>
                    </>
                );
            case "Upload":
                return (
                    <>
                    <div className={device === "desktop" ? "scoutingPage" : "mobileScoutingPage"}>
                        <div className='wifiDiv'>
                            <Wifi />
                    <OctopusStatus eventPath={eventPath} />
                        </div>
                        <div className='payloadToggleSection'>
                            <label className='payloadToggleLabel'>
                                <input
                                    type='checkbox'
                                    checked={useCompressedUploadPayload}
                                    onChange={toggleUploadPayloadMode}
                                />
                                <span>{'Compressed Mode'}</span>
                            </label>
                        </div>
                        <div className='qrContainer'>
                            <div className={'qrInner'}>
                                {canShowQr ? (
                                    <QRCodeSVG
                                        value={qrPayload}
                                        size={300}
                                        level="L"
                                    />
                                ) : (
                                    <p className='qrUnavailable'>
                                        {qrUnavailableHint}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className='qrString'
                                onClick={e => {copyString(qrPayload)}}>
                            <p>{qrPayload}</p>
                        </div>
                        <div className='uploadBtnSection'>
                            <span><span style={{fontWeight:"bold"}}>Event Path: </span> {!eventPath || eventPath === "" ? "N/A" : eventPath}</span>
                            <div className='uploadBtns'>
                                <p>Upload Mode: {gamemodes[gamemode]}</p>
                                <p>Change Game Mode for Upload: </p>
                                <div className={sliderStyles.themeOptions} style={{flexDirection: "column"}}>
                                    {gamemodes.map((item, index) => (
                                        <div className={sliderStyles.touchingBox}>
                                            <div className={sliderStyles.container} style = {{flexDirection: "row", justifyContent:"space-between"}}>
                                                <label className={sliderStyles.switch}>
                                                    <input type="checkbox" checked={parseInt(gamemode) === parseInt(index)} onChange={() => {
                                                        if (index === 3 && gamemode !== 3) {
                                                            setShowElimsPosModal(true);
                                                        } else if (index !== 3 && gamemode === 3) {
                                                            setPendingGameMode(index);
                                                            setShowQualsPosModal(true);
                                                        } else {
                                                            setGameMode(index);
                                                        }
                                                    }} />
                                                    <span className={sliderStyles.slider}></span>
                                                </label>
                                                <span>{item}</span>
                                            </div>
                                        </div>
                                    ))}
                                {showElimsPosModal && (
                                    <>
                                        <div className="tint"></div>
                                        <div className="notifSection">
                                            <div style={{display:"flex", flexDirection:"column", gap:"10px", width:"100%"}}>
                                                <p className="notifSectionText">Select Alliance Position</p>
                                                {elimsPositions.map((pos, i) => (
                                                    <button key={pos} className="pageButton" onClick={() => {
                                                        const newMap = new Map(initialDataMap);
                                                        newMap.set("team_position", i + 1);
                                                        setInitialDataMap(newMap);
                                                        setGameMode(3);
                                                        setShowElimsPosModal(false);
                                                    }}>{pos}</button>
                                                ))}
                                                <button className="pageButton notifSectionB1" style={{backgroundColor: "var(--errColor)"}} onClick={() => setShowElimsPosModal(false)}>Cancel</button>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {showQualsPosModal && (
                                    <>
                                        <div className="tint"></div>
                                        <div className="notifSection">
                                            <div>
                                                <p className="notifSectionText">Select Robot Position (1-3)</p>
                                                <div style={{display:"flex", flexDirection:"row", gap:"10px", margin:"10px 0"}}>
                                                    {[1, 2, 3].map((pos) => (
                                                        <button key={pos} className="pageButton" onClick={() => {
                                                            const newMap = new Map(initialDataMap);
                                                            newMap.set("team_position", pos);
                                                            setInitialDataMap(newMap);
                                                            setGameMode(pendingGameMode);
                                                            setPendingGameMode(null);
                                                            setShowQualsPosModal(false);
                                                        }}>{pos}</button>
                                                    ))}
                                                </div>
                                                <button className="pageButton notifSectionB1" style={{backgroundColor: "var(--errColor)"}} onClick={() => {
                                                    setPendingGameMode(null);
                                                    setShowQualsPosModal(false);
                                                }}>Cancel</button>
                                            </div>
                                        </div>
                                    </>
                                )}
                                </div>
                                <div class="button-container">
                                    <button
                                        className='uploadBtn1 uiButton'
                                        onClick={handleSubmit}>
                                            Submit
                                    </button>
                                    {usbSupported() && (
                                        <button
                                            className='uploadBtn1 uiButton'
                                            title="Save and write to a folder you pick (a flash drive) - no upload"
                                            onClick={handleExportToFolder}>
                                                Export
                                        </button>
                                    )}
                                </div>
                            </div>            
                        </div>
                        <div className='extraSection'>
                            <button className='abortBtn' onClick={() => {setShowNotification("abort") }}>Abort</button>
                        </div>
                        {device === "desktop" ? (
                            <button className='prevButton pageButton' onClick={() => switchPage('Post')}>Prev</button>
                        ) : (
                            <>
                            <button className='prevButton pageButton' onClick={() => switchPage('Post')}>Prev</button>
                            <div style={{visibility:"hidden"}}>I &lt;3 one piece</div>
                            </>
                        )}
                    </div>
                        
                    </>
                );
            case "timekeep":
                return (
                <Timekeeper 
                    currentTab={currentPage}
                    setCurrentTab={setCurrentTab}
                    setCurrentPage={setCurrentPage}
                    dataMap={dataMap}
                    settingsYear={settingsYear}
                    gamemode={gamemode}
                    eventPath={eventPath}
                    eventList={eventList}
                    onlineStatus={onlineStatus}
                    scoutDataMap={dataMap}
                    onSubmitted={timekeepSubmitted}
                />)
                break
            default: //start page
                return (
                    <div className='subpage'>
                        <div className={homeStyles.titleContainer}>
                            <h1 className={homeStyles.title}>★&nbsp;&nbsp;Osprey&nbsp;&nbsp;★</h1>
                        </div>
                        <div className='moreStartOptions'>
                            <MoreStartOptions 
                                rebuiltMissType={rebuiltMissType}
                                setRebuiltMissType={setRebuiltMissType}
                                settingsYear={settingsYear}
                            />
                            
                        </div>

                    <div className={homeStyles.configSection}>
                            {Object.entries(settings.start).map(([key, info]) => (
                                <React.Fragment key={key}>
                                {info.label === "alliance_color" && bBotLabel(startScoutData.get("team_number")) && (
                                    // The box keeps the demo number (9974) the data is filed under; this is the name TBA uses.
                                    <div className='startScoutInfoLabels bBotNote'>B-bot: {bBotLabel(startScoutData.get("team_number"))}</div>
                                )}
                                {!(info.label in startScoutPage) ? (
                                        <div key={key} className='startScoutInfoLabels'>
                                            {info.label === "alliance_color" ? (
                                                info.display + ": " + (initialDataMap.get(info.label) === 'r' ? "Red" : "Blue")
                                            ) : info.label === "team_position" ? (
                                                info.display + ": " + (
                                                    gamemode === 3
                                                        ? (elimsPositions[initialDataMap.get(info.label) - 1] || "N/A")
                                                        : (initialDataMap.get(info.label) || "N/A")
                                                )
                                            ) : (
                                                info.display + ": " + (initialDataMap.get(info.label) || "N/A")
                                            )}
                                        </div>
                                    ) : (
                                        <div key={key} className={homeStyles.inputSection}>
                                            <span className={homeStyles.displayLabel}>{info.display}</span>
                                            <input
                                                className="textInput"
                                            maxLength={info.maxLength}
                                            type="number"
                                            inputMode='numeric'
                                            disabled={tbaOnline && info.label.includes("team") ? false : false }
                                            value={startScoutData.get(info.label) || ""}
                                            onChange={e => handleChange(info.label, e.target.value,info.maxLength)}
                                            placeholder={info.placeholder}
                                        />
                                    </div>
                                )}

                                </React.Fragment>
                            ))}
                                                            
                        </div>
                        
                        <Backarrow setCurrentTab={setCurrentTab}/>

                        <div className='scoutButtonSection'>
                            {(tbaOnline || tbaStatus === "noSchedule") && (
                                <button className="uiButton" onClick={() => {
                                    refresh();
                                    // re-run autofill after refresh completes
                                }}>
                                    Refresh TBA
                                </button>
                            )}
                            {parseInt(settingsYear) === 2026 ? (
                                <>
                                    <button className=" uiButton" onClick={() => {
                                        switchPage("timekeep");
                                    }}>Timekeep</button>
                                    <button className=" uiButton" onClick={() => {
                                        setRebuiltScoutingMode(1);
                                        startScouting(1);
                                    }}>Count Mode</button>
                                    
                                    {/* <button className=" uiButton" onClick={() => {
                                            setRebuiltScoutingMode(0);
                                            startScouting();
                                    }}>Timer Mode</button> */}
                                </>
                            ) : (
                                <button className="scoutButton uiButton" onClick={() => {
                                        setRebuiltScoutingMode(0);
                                        startScouting();
                                }}>Begin</button>
                            )}
                            
                        </div>
                        
                    </div>
                )
        }
    };
    // Checks if there are any improper data values and sends alert
    function NAChecker(processedAlerts = alertList){
        const notApplicables = settings.notApplicables || {};
        const seenAlerts = Array.isArray(processedAlerts) ? processedAlerts : [];

        // Show one checker notice at a time. If none apply, go to toPost confirmation.
        for (const key of Object.keys(notApplicables)) {
            if (seenAlerts.includes(key)) continue;
            let allConditionsPassed = true;
            const condition = notApplicables[key];
                try {
                    // Evaluates each condition to see if a data value is improper or not
                    if (!eval(condition)) {
                        console.log(condition)
                        allConditionsPassed = false;
                    }
                } catch (err) {
                    console.error("NA checker condition failed:", condition, err);
                    allConditionsPassed = false;
                    break;
                }
            // if a data value is improper, it sends an alert
            if (allConditionsPassed) {
                setCheckerMessage(settings.NAmessage[key]);
                setAlertList([...seenAlerts, key]);
                setShowNotification("checker");
                return;
            }
        }
        // after going through each data value and sending any alerts needed, it shows the toPost alert
        setShowNotification("toPost");
    }

    const renderNotifs = (type) => {
        let display = false;
        let text = "yup"
        switch (type) {
            case "abort": //abort match dont save
                display = true;
                text = "Are you sure you want to reset the match? All current match data will be lost.";
                break;
            case "toPost": //continue to post page
                display = true;
                text = "Are you sure you want to exit the scouting page? You cannot return once you leave.";
                break;
            case "loading":
                display = true;
                text = "loading";
                break;
            case "checker":
                display = true;
                text = checkerMessage;
                break;
            default:
                display = false;
                break;
        }
        if(!display) return (<div className='invisible'>hello</div>)
        
        if(type == "loading"){
            return (
                <div className='spinnerContainer'>
                     <div className="tint"></div>
                    <div className='spinner'></div>
                </div>
            )
        }
        const modalMotion = animPreset ? {
            initial: animPreset.modal.initial,
            animate: animPreset.modal.animate,
            transition: animPreset.modal.transition,
        } : {};
        const tintMotion = animPreset ? {
            initial: { opacity: 0 },
            animate: { opacity: 0.7 },
            transition: animPreset.backdrop,
        } : {};
        return (
            <>
                <motion.div key={type + "Tint"} className="tint" {...tintMotion}></motion.div>
                <div className={`notifSection${type === "checker" ? " notifSectionWarning" : ""}`}>
                        <motion.div key={type + "Modal"} {...modalMotion}>
                            <p className="notifSectionText">{text}</p>
                            <button className="pageButton notifSectionB1" onClick={() => {
                                setShowNotification("nothing")
                                holdingShift.current = false;
                            }}>Cancel</button>
                            <button className="pageButton notifSectionB2" onClick={() => {
                                switch (type) {
                                    case "abort": //abort match dont save
                                        abortMatch();
                                        break;
                                    case "checker": //after checking for any missing data, go to post page
                                        NAChecker(alertList)
                                        break;
                                    default: //continue to post page
                                        setCurrentPage("Post");
                                        setTimerRunning(false);
                                        holdingShift.current = false;
                                    setShowNotification("nothing");
                                }
                            }}>Confirm</button>
                        </motion.div>
                </div>
            </>
        )
    }

    if (currentTab === "scout"){
        return (
            <div className="ScoutPage">
                <PickingSection
                    visible={pickingVisible}
                    onClose={() => setPickingVisible(false)}
                    onDataSelect={handlePickingData}
                    currentQataValue={dataMap.get(getQataKey(qataMode))}
                    currentPage={currentPage}
                    mode={qataMode}
                    shouldAutoImport={shouldAutoImportPicking}
                    gameSessionId={gameSessionId}
                    qataQuestions={qataQuestions}
                />
                {tkRotation && (currentPage === "start" || currentPage === "timekeep") && (
                    <div className='timekeepCounter'>Time keeper scouted bots: {tkRotation.count}/{ROBOTS_PER_MATCH}</div>
                )}
                <div ref={subpageRef}>
                    {renderPage(currentPage)}
                </div>
                {renderNotifs(showNotification)}
                
            </div>
        );
    }
    else return;
}
export default Scout;
